export default "__VITE_ASSET__DsLflbyh__"